/**
 * getLocale — module-level locale reference assigned by I18nProvider on mount.
 *
 * The provider sets the active locale via `setLocale()` when it mounts or when
 * the locale changes. Consumers (date/currency/number formatters in
 * `apps/dashboard/src/api/utils/time.ts` and similar) read the current locale
 * via `getLocale()` without needing React context access.
 *
 * Default: "en-US" (synchronous English fallback when I18nProvider has not
 * mounted or when the feature flag is off).
 *
 * Source contract: specs/prd.md FR-023.
 */

/** The currently active locale identifier. */
let _locale = "en-US";

/**
 * Returns the currently active BCP 47 locale tag.
 *
 * Safe to call from non-React code (formatters, utilities). Returns "en-US"
 * before the provider mounts.
 */
export function getLocale(): string {
  return _locale;
}

/**
 * Sets the active locale. Called only by I18nProvider — do not call directly
 * from consumer code.
 *
 * @internal
 */
export function setLocale(locale: string): void {
  _locale = locale;
}
